var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2553_51871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33348 16C9.18924 16 9.04888 15.9532 8.93348 15.8667L6.26682 13.8667C6.18402 13.8046 6.11682 13.724 6.07053 13.6315C6.02425 13.5389 6.00015 13.4368 6.00015 13.3333V9.58667L1.32282 4.32467C0.99063 3.94992 0.773736 3.48721 0.698203 2.99216C0.62267 2.4971 0.691713 1.99077 0.897032 1.53401C1.10235 1.07725 1.43521 0.689506 1.8556 0.417377C2.276 0.145249 2.76603 0.000316279 3.26682 0L12.7335 0C13.2342 0.000587367 13.7241 0.14576 14.1444 0.418071C14.5646 0.690383 14.8972 1.07825 15.1023 1.53506C15.3074 1.99187 15.3763 2.49818 15.3005 2.99316C15.2248 3.48815 15.0078 3.95073 14.6755 4.32533L10.0002 9.58667V15.3333C10.0002 15.5101 9.92991 15.6797 9.80489 15.8047C9.67986 15.9298 9.5103 16 9.33348 16Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2553_51871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlack);
export default __webpack_public_path__ + "static/media/filterBlack.3f078ad8157d35f119b22eb7a479c816.svg";
export { ForwardRef as ReactComponent };